var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"})
}
var staticRenderFns = []

export { render, staticRenderFns }